import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchAutoDataFailure } from '../actions/autoDataActions';

import KaskoItem from '../views/KascoItem';

const mapStateToProps = (store) => {
  return {
    offers: store.offers.offers
  };
};

export default connect(mapStateToProps)(KaskoItem);
